<template>
  <v-container fluid class="white elevation-4 pt-0">
    <main-app-bar :title="$router.currentRoute.meta.title">
      <template v-slot:buttons>
        <v-btn rounded color="primary" :to="{name:'addEmployee'}">
          <v-icon left>mdi-plus</v-icon> Add Employee
        </v-btn>
      </template>
    </main-app-bar>
    <v-row class="d-flex grey lighten-4">
      <v-toolbar
        flat
        class="pa-0 transparent"
      >
        <v-btn color="black lighten-2" text class="btn-filter pa-1" @click="filterOpened = !filterOpened">Filters <v-icon right>$filter</v-icon></v-btn>

          <div class="ml-5" style="width: 50%;">
              <v-chip v-for="chip in filterChips" :key="chip.id"
                      close small
                      v-on:click:close="removeTag(chip)"
                      close-icon="mdi-close" color="primary" class="ma-1 lighten-1">
                  {{chip.title}}
              </v-chip>
          </div>
        <v-spacer></v-spacer>
          <v-text-field
              ref='searchStaff'
              v-model="searchName"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              :disabled="isLoading"
              style="max-width: 400px; width: 35%;"
          ></v-text-field>
      </v-toolbar>
      <v-expand-transition>
        <v-card v-show="filterOpened" elevation="0" class="px-5 transparent" height="auto" style=" width: 100%;" :disabled="isLoading">
          <v-row class="d-flex align-center justify-space-between">
            <v-flex class="d-flex">
              <v-col xs-3 class="d-flex flex-column" style="max-width: 300px">
              <v-flex>
                <div class="pt-2">Clinic:</div> <v-select
              multiple
              v-model="filterOptions.clinics"
              :items="$store.getters.getClinics"
              item-text="title"
              item-value="id"
              placeholder="Select clinics"
              dense
              solo
              lighten-1
              class="ml-2"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterOptions.roles.length - 1 }} others)</span>
              </template>
            </v-select>
              </v-flex>
              <v-flex>
                <div class="pt-2">Roles:</div> <v-select
              multiple
              v-model="filterOptions.roles"
              :items="$store.getters.getRoles"
              item-text="title"
              item-value="id"
              placeholder="Select roles"
              dense
              solo
              lighten-1
              class="ml-2 pa-0"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterOptions.roles.length - 1 }} others)</span>
              </template>
            </v-select>
              </v-flex>
            </v-col>
            <v-col xs-3 class="d-flex flex-column ml-5" style="max-width: 300px">
              <v-flex>
                <div class="pt-2">Groups:</div> <v-select
              multiple
              v-model="filterOptions.groups"
              :items="$store.getters.getGroups"
              item-text="title"
              item-value="id"
              placeholder="Select groups"
              dense
              solo
              lighten-1
              class="ml-2 pa-0"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="selection-text-style">{{ item.title }}</span>
                <span
                  v-if="index === 1"
                  class="grey--text caption"
                >(+{{ filterOptions.groups.length - 1 }} others)</span>
              </template>
            </v-select>
              </v-flex>
            </v-col>
            </v-flex>
            <v-flex xs3>
              <v-col cols="3" class="d-flex">
              <v-col class="pa-0" cols="1" style="min-width: 90px;">
                Statuses:
              </v-col>
              <v-col class="pa-0">
                <v-checkbox label="Active" v-model="filterOptions.statuses" :value="true" class="ma-0"></v-checkbox>
                <v-checkbox label="InActive" v-model="filterOptions.statuses" :value="false" class="ma-0"></v-checkbox>
              </v-col>
            </v-col>
            </v-flex>
          </v-row>
        </v-card>
      </v-expand-transition>
    </v-row>
    <v-row>
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="employees"
        :options.sync="options"
        :items-per-page="10"
        :hide-default-footer="employees.length === 0 ? true : false"
        :server-items-length="employeeTotal"
        class="elevation-0 d-block"
        :footer-props="{
          'items-per-page-options': [5,10,15,20],
        }"
      >
        <template v-slot:body="{ items }" class="d-block">
          <tr :key="employee.id" v-for="employee of items" @click="$router.push({ name: 'editEmployee', params: { id: employee.id } })">
            <td style="word-break: break-all">
              {{ employee.firstName }}
            </td>
            <td style="word-break: break-all">
              {{ employee.lastName }}
            </td>
            <td style="word-break: break-all">
              {{ employee.email }}
            </td>
            <td>
              {{ employee.groups | concatGroups }}
            </td>
            <td>
              {{ employee.clinicRoles | concatClinics }}
            </td>
              <td>
                {{ employee.holidayAllowance ? employee.holidayAllowance : '*' }}
              </td>
            <td>
              {{ employee.status ? 'Active' : 'Inactive' }}
            </td>
            <td align="right">
              <v-btn icon fab small primary="transparent" class="elevation-0">
                <v-icon medium>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-pagination v-if="employees.length && totalPages > 1" v-model="options.page" :length="totalPages" :total-visible="paginationTotalVisible"></v-pagination>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import MainAppBar from '@/components/MainAppBar'
  import config from '@/common/config'
  export default {
      data: () => ({
          filterOptions: {
              roles: [],
              clinics: [],
              groups: [],
              statuses: [true]
          },
          searchName: '',
          filterOpened: false,
          employeeTotal: 0,
          paginationTotalVisible: config.paginationTotalVisible,
          options: {
              page: 1,
              itemsPerPage: 10,
              sortBy: Array(0),
              sortDesc: Array(0),
              // groupBy: Array(0)
              // groupDesc: Array(0)
              mustSort: false,
              multiSort: false
          },
          headers: [
              {
                  text: 'First Name',
                  align: 'left',
                  sortable: true,
                  value: 'firstName',
                  width: 120
              },
              {
                  text: 'Last Name',
                  align: 'left',
                  sortable: true,
                  value: 'lastName',
                  width: 120
              },
              {
                  text: 'Email/Username',
                  align: 'left',
                  sortable: true,
                  value: 'email'
              },
              {
                  text: 'Group',
                  align: 'left',
                  sortable: false,
                  value: 'group'
              },
              {
                  text: 'Clinic-role',
                  align: 'left',
                  sortable: false,
                  value: 'isActive'
              },
              {
                  text: 'Allowance',
                  align: 'left',
                  sortable: true,
                  value: 'holidayAllowance',
                  width: 110
              },
              {
                  text: 'Status',
                  align: 'left',
                  sortable: true,
                  value: 'status',
                  width: 100
              },
              {
                  text: '',
                  align: 'left',
                  sortable: false,
                  value: '',
                  width: 70
              }
          ],
          isLoading: true,
          filteringTimeId: null
      }),
    computed: {
      ...mapGetters({
        employees: 'getEmployees'
      }),
      totalPages: function () {
        return Math.ceil(this.employeeTotal / this.options.itemsPerPage)
      },
      filterChips: function () {
        const filterTags = []
        for (const key in this.filterOptions) {
          const optionValue = this.filterOptions[key]
          if (Array.isArray(optionValue)) {
            optionValue.forEach(opt => {
              const tag = {
                id: this.$uuid.v1(),
                key
              }
              switch (key) {
                case 'clinics':
                  tag.title = this.$store.getters.getClinicById(opt).title
                  tag.value = this.$store.getters.getClinicById(opt).id
                  break
                case 'roles':
                  tag.title = this.$store.getters.getRoleById(opt).title
                  tag.value = this.$store.getters.getRoleById(opt).id
                  break
                case 'groups':
                  tag.title = this.$store.getters.getGroupById(opt).title
                  tag.value = this.$store.getters.getGroupById(opt).id
                  break
                case 'statuses':
                  if (opt) {
                    tag.title = 'Active'
                  } else {
                    tag.title = 'Inactive'
                  }
                  tag.value = opt
                  break
              }
              filterTags.push(tag)
            })
          } else {
            if (optionValue) {
              const tag = {
                id: this.$uuid.v1(),
                key
              }
              tag.title = key
              filterTags.push(tag)
            }
          }
        }
        return filterTags
      }
    },
    watch: {
      filterOptions: {
        handler () {
          this.options.page = 1
          this.getEmployeesDebounce()
        },
        deep: true
      },
      searchName () {
        this.options.page = 1
        this.getEmployeesDebounce(1000)
      },
      options: {
        handler () {
          /* const query = {
            page: this.options.page
          }
          const currentPage = this.$router.currentRoute.query.page
          if (+this.options.page !== +currentPage) {
            if (this.options.page === 1) {
              delete query.page
            }
            if (currentPage || (this.options.page !== 1)) {
              this.$router.push({
                query
              })
            }
          } */
          this.getEmployeesDebounce()
        },
        deep: true
      }
    },
      methods: {
          ...mapActions(['fetchEmployees']),
          async getEmployees () {
              this.isLoading = true
              const params = {
                  ...this.options,
                  groups: this.filterOptions.groups,
                  filterOptions: {
                      ...this.filterOptions,
                      name: this.searchName,
                      sortField: this.options.sortBy[0] || 'firstName',
                      sortOrder: this.options.sortDesc[0] ? 'DESC' : 'ASC'
                  }
              }
              const metaData = await this.fetchEmployees(params)
              this.employeeTotal = metaData.totalElements
              this.isLoading = false
              const input = this.$refs.searchStaff.$refs.input
              setTimeout(() => {
                input.focus()
              }, 100)
          },
          getEmployeesDebounce (timeout = 200) {
              clearTimeout(this.filteringTimeId)
              this.filteringTimeId = setTimeout(this.getEmployees, timeout)
          },
          removeTag (chip) {
              if (chip.key) {
                  const filterOption = this.filterOptions[chip.key]
                  if (Array.isArray(filterOption)) {
                      this.filterOptions[chip.key] = filterOption.filter(option => chip.value !== option)
                  } else {
                      this.filterOptions[chip.key] = false
                  }
              }
          }
      },
    filters: {
      concatClinics (clinicRoles) {
        if (!clinicRoles) {
          return []
        }
        let clinicRoleStr = ''
         clinicRoles.forEach(clinicRole => {
           clinicRoleStr += clinicRole.id + (clinicRole.value ? ' - ' + clinicRole.value : '') + ' / '
        })
        clinicRoleStr = clinicRoleStr.substring(0, clinicRoleStr.length - 3)
        if (clinicRoleStr.length > 40) {
          clinicRoleStr = clinicRoleStr.substr(0, 40) + '...'
        }
        return clinicRoleStr
      },
      concatGroups (groups) {
        if (!groups || groups.length === 0) {
          return ''
        }
        let groupsStr = ''
        groups.forEach(group => {
          groupsStr += group + ' / '
        })
        groupsStr = groupsStr.substring(0, groupsStr.length - 3)
        if (groupsStr.length > 40) {
          groupsStr = groupsStr.substr(0, 40) + '...'
        }
        return groupsStr
      }
    },
    async mounted () {
      this.$store.dispatch('fetchRoles')
      try {
        /* const metaData = await this.fetchEmployees(this.options)
        this.employeeTotal = metaData.total */
        const query = this.$router.currentRoute.query
        if (query.page) {
          this.options.page = query.page ? +query.page : 1
        }
        this.isLoading = false
      } catch (e) {
        console.warn(e)
      }
    },
    components: {
      MainAppBar
    }
  }
</script>

<style scoped lang="scss">
  .v-data-table::v-deep {
    width: 100%;
    table{
      table-layout: fixed;
    }
  }

  .btn-filter {
    svg {
      fill: #000
    }
  }
  .selection-text-style {
    font-size: 13px;
  }
  .expand-transition-enter-active, .expand-transition-leave-active {
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }

</style>
